import { createHooks } from '@wordpress/hooks';

window.feWp = {
  hooks: createHooks()
};

window.wp = window.wp || { hooks: createHooks() };
